import { render, staticRenderFns } from "./Abap.vue?vue&type=template&id=45687960&scoped=true&"
import script from "./Abap.vue?vue&type=script&lang=js&"
export * from "./Abap.vue?vue&type=script&lang=js&"
import style0 from "./Abap.vue?vue&type=style&index=0&id=45687960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45687960",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCardTitle,VSheet})
